module.exports = __webpack_public_path__ + "static/favicon.83181041.ico";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/favicon.ico
// module id = 756
// module chunks = 114276838955818